import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Query, Result } from "../../../../interfaces";
import { Find } from "../../../commons";
import { Adapter } from "../../../../shared/adapter";
import { CommonsAdapter } from "../../../../adapter/commons-adapter";

export const FETCH_DATA_COMMONS_REQUEST = "FETCH_DATA_COMMONS_REQUEST";
export const FETCH_DATA_COMMONS_SUCCESS = "FETCH_DATA_COMMONS_SUCCESS";
export const FETCH_DATA_COMMONS_FAILURE = "FETCH_DATA_COMMONS_FAILURE";

interface ActionPagination<T> {
  type: string;
  payload: T;
}

const fetchDataCommonsRequest = () => {
  return {
    type: FETCH_DATA_COMMONS_REQUEST,
  };
};

const fetchDataCommonsSuccess = (data: any): ActionPagination<Result<any>> => {
  return {
    type: FETCH_DATA_COMMONS_SUCCESS,
    payload: data,
  };
};

const fetchDataCommonsFailure = (error: any) => {
  return {
    type: FETCH_DATA_COMMONS_FAILURE,
    payload: error,
  };
};

export const find = (page: number, pageSize: number, query: Query) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchDataCommonsRequest());
    try {
      const response = await Find("commons", query, page, pageSize);
      dispatch(
        fetchDataCommonsSuccess({
          meta: response.meta,
          values: Adapter.from(response.data).to((value) =>
            new CommonsAdapter(value).adapt()
          ),
        })
      );
    } catch (error: any) {
      dispatch(fetchDataCommonsFailure(error.message));
    }
  };
};
